export function scrollToId(scrollTargetId: string): void {
  const element = document.getElementById(scrollTargetId);
  if (!element) return;
  const elementTop = element.getBoundingClientRect().top;
  const targetHeight = elementTop + window.pageYOffset;
  if (document.documentElement.scrollTo !== undefined) {
    document.documentElement.scrollTo({ top: targetHeight, behavior: 'smooth' });
  } else {
    // IE対応: IEはスムーズスクロールはしない
    window.scrollTo(0, targetHeight);
  }
}

/**
 * 主にVue.js内遷移用。スクロール状態のリセット。
 */
export function jumpToTop(): void {
  window.scrollTo(0, 0);
}
